import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  UploadImageComponent,
  UploadImageDialogData,
} from 'src/app/modules/shared/components/dialogs/upload-image/upload-image.component';
import { DOCUMENT_STATUS, DOCUMENT_TYPE } from '../../../models/User';
import { AuthService } from '../../../abstraction/auth.service';

@Component({
  selector: 'app-selfie',
  templateUrl: './selfie.component.html',
  styleUrls: ['./selfie.component.scss'],
})
export class SelfieComponent implements OnInit {
  fundOriginSent: boolean;
  constructor(private dialog: MatDialog, private authSvc: AuthService) {}

  ngOnInit(): void {
    this.authSvc.loggedUserObs.subscribe(
      (user) => (this.fundOriginSent = user?.fundsDocuments?.selfie === DOCUMENT_STATUS.PENDING),
    );
  }

  openUploadImageWindow() {
    this.dialog
      .open<UploadImageComponent, UploadImageDialogData>(UploadImageComponent, {
        panelClass: 'modal-container',
        data: {
          title: 'Subir selfie',
          body: 'Asegurate de cumplir los requisitos previamente mencionados',
          options: ['Subir'],
          documentType: DOCUMENT_TYPE.SELFIE,
          successMessage:
            '¡Imagen subida con éxito! <br> Las imagenes serán validadas dentro de las próximas 24Hs hábiles.',
          disableComment: true,
        },
      })
      .afterClosed()
      .subscribe((uploadedImage) => {
        this.fundOriginSent = uploadedImage ? true : false;
      });
  }
}
